import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';
import itemNS from './constants/revenueNS';

export default data => {
  const dataCreate = parseToMutationRequest(data, itemNS);
  const createRevenueMilestone = `createRevenueMilestone(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createRevenueMilestone} {
      id
    }
  }
`;
};
